import React from "react";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import CustomInput from "../../../components/CustomInput/CustomInputValidate";
import { clone, parseFloatString, round2dec, twoDecimals } from "../../../shared/utility";
import { calculateBrokerCommission } from "./BrokersLogic";
import CustomSimpleDialog from "components/CustomDialog/CustomSimpleDialog";
import Button from "../../../components/CustomButtons/Button";
import { useState } from "react";
import { useMemo } from "react";

const CommissionDistribution = props => {
    const [openedInput, setOpenedInput] = useState(null);
    const [input, setInput] = useState('');
    const { data, setData, 
        label_one, label_two, 
        field_one, field_two,  // lessee lessor
        label_three = 'Assignor', field_three = 'commission_distribution_assignor', // assignor
        show_assignor
    } = props;

    const total = (data[field_one] ? parseFloat(data[field_one]) : 0) +
        (data[field_two] ? parseFloat(data[field_two]) : 0) +
        (data[field_three] ? parseFloat(data[field_three]) : 0);

    console.log('toot', data[field_one], data[field_two]);

    const validInput = input !== '' ? true : false;

    const lockedBySameAssociates = data.same_illi_associates === 'Yes';

    const submit = () => {
        if (!openedInput) return
        if (openedInput.label === 'Lessee' || openedInput.label === 'Buyer' || openedInput.label === 'Assignee') {
            const newData = clone(data);
            newData.commission_distribution_lessee = input;
            if (parseFloat(input) === 100) {
                newData.commission_distribution_lessor = '0.00';
                newData.commission_splits_agent = [];
            }
            setData(newData);
        } else if (openedInput.label === 'Lessor' || openedInput.label === 'Seller') {
            const newData = clone(data);
            newData.commission_distribution_lessor = input;
            if (parseFloat(input) === 100) {
                newData.commission_distribution_lessee = '0.00';
                newData.commission_splits_agent2 = [];
            }
            setData(newData);
        } else if (openedInput.label === 'Assignor') {
            const newData = clone(data);
            newData.commission_distribution_assignor = input;
            if (!newData.commission_splits_agent3) newData.commission_splits_agent3 = [];
            if (parseFloat(input) === 100) {
                newData.commission_distribution_lessee = '0.00';
                newData.commission_distribution_lessor = '0.00';
                newData.commission_splits_agent2 = [];
                newData.commission_splits_agent = [];
            }
            setData(newData);
        }
        setOpenedInput(null);
    }

    return <>
        {openedInput && <CustomSimpleDialog 
            no_ok_button={true} 
            open={true}
            close={() => {
                setOpenedInput(null);
            }}
            content={<div>
                <h3>{openedInput.label}</h3>
            <div style={{maxWidth:140}}>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    submit();
                }}>
                <CustomInput 
                    value={input}
                    onChange={(e) => {
                        setInput(e.target.value);
                    }}
                    validate={[]}
                    endAdornment="%"
                    isCurrency={true}
                    autoFocus={true}
                />
                <Button 
                    color="primary"
                    disabled={validInput ? false : true}
                    onClick={() => {
                        submit();
                    }}
                >SUBMIT</Button>
                </form>
            </div></div>}
        />}
    <div style={{marginLeft:20,width:'100%'}}>
        <GridContainer>
            <GridItem xs={12} sm={3} md={3}>
                <h3>Commission Distribution</h3>
                <div className="group-list">
                    <div className="bordered-list">
                        <ul>
                            <li style={{opacity: (data[field_two] == 100 || lockedBySameAssociates) ? 0.5 : 1}}>
                                <CustomInput
                                    label={label_one}
                                    value={data[field_one]}
                                    onClick={() => {
                                        if (lockedBySameAssociates) return;
                                        setInput(data[field_one]);
                                        setOpenedInput({
                                            label: label_one,
                                            field: field_one
                                        });
                                    }}
                                    validate={[]}
                                    endAdornment="%"
                                    isCurrency={true}
                                    disabled={data[field_two] == 100 || lockedBySameAssociates ? true : false}
                                />
                            </li>
                            <li style={{opacity: (data[field_one] == 100 && !lockedBySameAssociates) ? 0.5 : 1}}>
                                <CustomInput
                                    label={label_two}
                                    value={data[field_two]}
                                    onClick={() => {
                                        if (lockedBySameAssociates) return;
                                        setInput(data[field_two]);
                                        setOpenedInput({
                                            label: label_two,
                                            field: field_two
                                        });
                                    }}
                                    validate={[]}
                                    endAdornment="%"
                                    isCurrency={true}
                                    disabled={data[field_one] == 100 || lockedBySameAssociates ? true : false}
                                />
                            </li>
                            {show_assignor && <li style={{opacity:(data[field_one] == 100 || data[field_three] == 100) ? 0.5 : 1}}>
                                <CustomInput
                                    label={label_three}
                                    value={data[field_three]}
                                    onClick={() => {
                                        setInput(data[field_three]);
                                        setOpenedInput({
                                            label: label_three,
                                            field: field_three
                                        });
                                    }}
                                    validate={[]}
                                    endAdornment="%"
                                    isCurrency={true}
                                    disabled={(data[field_one] == 100 || data[field_two] == 100) ? true : false}
                                />
                            </li>}
                            <li>
                                <div className="mb-20">
                                    TOTAL : <span style={{color:total === 100 ? 'green' : 'red'}}>{round2dec(total)}</span> %
                                </div>
                                {total !== 100 && <div><em>Total must be 100%</em></div>}
                            </li>
                        </ul>
                    </div>
                </div>
            </GridItem>
        </GridContainer>
    </div>
    </>
}

export default CommissionDistribution;

export const CommissionDistributionFull = props => {
    const { 
        name, 
        hasLessorAssociate,
        hasLesseeAssociate,
        data
    } = props;

    if (name === 'lessor') {
        const renderCommissionsLessor = () => {
            let tot = 0;
            if (data.commission_splits_agent) {
                data.commission_splits_agent.forEach(csa => {
                    tot += parseFloatString(csa.Percentage)
                })
            }
    
            return (
                <tbody>
                    <tr>
                        <td className="col-40">
                            <strong>Name</strong>
                        </td>
                        <td className="col-60">
                            <strong>Percentage</strong>
                        </td>
                    </tr>
                    {data.commission_splits_agent.map((c, i) => {
                        return (
                            <tr key={`${i}-agent`}>
                                <td className="col-40">{c.Name}</td>
                                <td className="col-60">{twoDecimals(parseFloatString(c.Percentage))} %</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td className="col-40">
                            <strong>Total</strong>
                        </td>
                        <td className="col-60">{twoDecimals(tot)} %</td>
                    </tr>
                </tbody>
            );
        };
        
        const renderCommissionsOtherLessor = () => {
            return (
                <tbody>
                    <tr>
                        <td className="col-40">
                            <strong>Name</strong>
                        </td>
                        <td className="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td className="col-30">
                            <strong>Commission Value</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-40">Lessor Referral</td>
                        <td className="col-30"></td>
                        <td className="col-30">
                            {data.referral_firm_fee_amount_choice === "Value"
                                ? data.referral_firm_fee_amount
                                : data.referral_firm_fee_amount_percentage + " %"}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-40">Lessor - Outside Broker(s)</td>
                        <td className="col-30"></td>
                        <td className="col-30">{calculateBrokerCommission('lessor_outside_broker', data)}</td>
                    </tr>
                </tbody>
            );
        };
    
        return <>
            <div>
                <h4 style={{ textDecoration: "underline" }}>COMMISSION DISTRIBUTION {name.toUpperCase()}</h4>
            </div>
            {hasLessorAssociate && <div className="the-table">
                <table>{renderCommissionsLessor()}</table>
            </div>}
            <div className="the-table mt-10" style={{display:'none'}}>
                <table>{renderCommissionsOtherLessor()}</table>
            </div>
        </>
    }

    if (name === 'lessee') {
        const renderCommissionsLessee = () => {
            let tot = 0;
            if (data.commission_splits_agent2) {
                data.commission_splits_agent2.forEach(csa => {
                    tot += parseFloatString(csa.Percentage)
                })
            }
    
            return (
                <tbody>
                    <tr>
                        <td className="col-40">
                            <strong>Name</strong>
                        </td>
                        <td className="col-60">
                            <strong>Percentage</strong>
                        </td>
                    </tr>
                    {data.commission_splits_agent2.map((c, i) => {
                        return (
                            <tr key={`${i}-agent`}>
                                <td className="col-40">{c.Name}</td>
                                <td className="col-60">{twoDecimals(parseFloatString(c.Percentage))} %</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td className="col-40">
                            <strong>Total</strong>
                        </td>
                        <td className="col-60">{twoDecimals(tot)} %</td>
                    </tr>
                </tbody>
            );
        };
        
        const renderCommissionsOtherLessee = () => {
            return (
                <tbody>
                    <tr>
                        <td className="col-40">
                            <strong>Name</strong>
                        </td>
                        <td className="col-60">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    <tr>
                        <td className="col-40">Lessee Referral</td>
                        <td className="col-60">
                            {data.lessee_referral_firm_fee_amount_choice === "Value"
                                ? data.lessee_referral_firm_fee_amount
                                : data.lessee_referral_firm_fee_amount_percentage + " %"}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-40">Lessee - Outside Broker</td>
                        <td className="col-60">{calculateBrokerCommission('outside_broker',data)}</td>
                    </tr>
                </tbody>
            );
        };

        return <>
            <div>
                <h4 style={{ textDecoration: 'underline' }}>COMMISSION DISTRIBUTION {name.toUpperCase()}</h4>
            </div>
            {hasLesseeAssociate && <div className="the-table">
                <table>
                    {renderCommissionsLessee()}
                </table>
            </div>}
            <div className="the-table mt-10" style={{display:'none'}}>
                <table>
                    {renderCommissionsOtherLessee()}
                </table>
            </div>
        </>
    }

    return null;
};